import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  KVariance_INVARIANT_instance = new (KVariance())('INVARIANT', 0);
  KVariance_IN_instance = new (KVariance())('IN', 1);
  KVariance_OUT_instance = new (KVariance())('OUT', 2);
}
var KVariance_INVARIANT_instance;
var KVariance_IN_instance;
var KVariance_OUT_instance;
var KVarianceClass;
function KVariance() {
  if (KVarianceClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'KVariance');
    KVarianceClass = $;
  }
  return KVarianceClass;
}
function KVariance_INVARIANT_getInstance() {
  static_init();
  return KVariance_INVARIANT_instance;
}
function KVariance_IN_getInstance() {
  static_init();
  return KVariance_IN_instance;
}
function KVariance_OUT_getInstance() {
  static_init();
  return KVariance_OUT_instance;
}
//region block: exports
export {
  KVariance_INVARIANT_getInstance as KVariance_INVARIANT_getInstance2ur2ikab74uh6,
  KVariance_IN_getInstance as KVariance_IN_getInstance24941hramdx4c,
  KVariance_OUT_getInstance as KVariance_OUT_getInstance2zbvv2i4ibp4m,
};
//endregion

//# sourceMappingURL=KVariance.mjs.map
